import { Card, Typography } from "antd";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

const { Title } = Typography;

interface CropStatusData {
  open: number;
  closed: number;
  converted: number;
  with_samples: number;
}

interface Props {
  data: CropStatusData;
  loading?: boolean;
}

const COLORS = {
  open: "#52c41a",
  closed: "#ff4d4f",
  converted: "#1890ff",
  with_samples: "#faad14",
};

export const CropStatusChart = ({ data, loading }: Props) => {
  const chartData = [
    { name: "Abiertos", value: data.open, color: COLORS.open },
    { name: "Cerrados", value: data.closed, color: COLORS.closed },
    { name: "Convertidos", value: data.converted, color: COLORS.converted },
    { name: "Con Muestras", value: data.with_samples, color: COLORS.with_samples },
  ];

  return (
    <Card loading={loading}>
      <Title level={5}>Distribución por Estado</Title>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};
